class SubscriptionController {}

export default SubscriptionController;



// WEBPACK FOOTER //
// ./client/app/subscription/subscription.controller.js